import Extinguisher from '../ExtinguisherVue.vue'

export const extinguisherRoute = [
  {
    path: '/extinguisher',
    name: 'extin',
    component: Extinguisher
  }
]
